// // export default EmiDueReport;
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// import "../css/EmiDueReport.css";
// import { useNavigate } from "react-router-dom";

// const GoldLoanEmiDueReport = () => {
//   const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

//   const [emis, setEmis] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [filter, setFilter] = useState("pending"); // default filter
//   const [company, setCompany] = useState(null);
//   const navigate = useNavigate();

//   const baseUrl = "https://payyug.in/api/loan-emi";

//   const apiUrls = {
//     pending: `${baseUrl}/overdue?superAdminId=${superAdminId}`,
//     today: `${baseUrl}/today?superAdminId=${superAdminId}`,
//     upcoming: `${baseUrl}/upcoming7days?superAdminId=${superAdminId}`,
//   };

//   useEffect(() => {
//       const fetchCompany = async () => {
//         try {
//           setLoading(true);
//           const response = await fetch(
//             `https://payyug.in/api/get-company?superAdminId=${superAdminId}`
//           );
//           const data = await response.json();

//           if (response.ok && data) {
//             // Dynamically construct logo URL
//             if (data.logo) {
//               data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, '')}`;
//             }
//             setCompany(data);
//           } else {
//             console.error('Failed to fetch company data');
//           }
//         } catch (err) {
//           console.error('Error fetching company details:', err);
//         } finally {
//           setLoading(false);
//         }
//       };

//       if (superAdminId) fetchCompany();
//     }, [navigate, superAdminId]);

//   useEffect(() => {
//    const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

//     const fetchEmis = async () => {
//       setLoading(true);
//       try {
//         const res = await axios.get(apiUrls[filter]);
//         setEmis(res.data.emis || []);
//       } catch (err) {
//         setError("Failed to fetch EMI due report");
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchEmis();
//   }, [filter]);

//   if (loading) return <div className="EmiDueReport-loading">Loading EMI Report...</div>;
//   if (error) return <div className="EmiDueReport-error">{error}</div>;

//   // Pagination logic
//   const totalPages = Math.ceil(emis.length / rowsPerPage);
//   const startIndex = (currentPage - 1) * rowsPerPage;
//   const currentData = emis.slice(startIndex, startIndex + rowsPerPage);

//   const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
//   const handleNext = () => currentPage < totalPages && setCurrentPage(currentPage + 1);

//   // PDF Export
// //   const handleDownloadPDF = () => {
// //   const doc = new jsPDF();
// //   doc.setFontSize(18);
// //   doc.text("Company EMI Demand Sheet", 14, 20);

// //   const tableColumn = [
// //     "#",
// //     "Customer Name",
// //     "Loan Number",
// //     "EMI Number",
// //     "EMI Amount",
// //     "Principal",
// //     "Interest",
// //     "Outstanding",
// //     "Due Date",
// //     "Status"
// //   ];

// //   const tableRows = currentData.map((emi, index) => [
// //     startIndex + index + 1,
// //     emi.customerName,
// //     emi.loanNumber,
// //     emi.emiNumber,
// //     emi.emiAmount,
// //     emi.principalComponent,
// //     emi.interestComponent,
// //     emi.outstanding,
// //     new Date(emi.dueDate).toLocaleDateString("en-IN"),
// //     emi.status
// //   ]);

// //   // ✅ Correct way in v3+ / v5+
// //   autoTable(doc, {
// //     startY: 30,
// //     head: [tableColumn],
// //     body: tableRows,
// //     theme: "grid",
// //     headStyles: { fillColor: [99, 102, 241], textColor: 255 },
// //     styles: { fontSize: 10, cellPadding: 3 }
// //   });

// //   doc.save("EMI_Demand_Sheet.pdf");
// // };

// const handleDownloadPDF = async () => {
//   const doc = new jsPDF("l", "mm", "a4"); // landscape

//   // Load logo as base64
//   const getImageBase64 = async (url) => {
//     const res = await fetch(url);
//     const blob = await res.blob();
//     return new Promise((resolve) => {
//       const reader = new FileReader();
//       reader.onloadend = () => resolve(reader.result);
//       reader.readAsDataURL(blob);
//     });
//   };

//   let logoBase64 = null;
//   if (company?.logoUrl) {
//     logoBase64 = await getImageBase64(company.logoUrl);
//   }

//   // === HEADER SECTION ===
//   if (logoBase64) {
//     doc.addImage(logoBase64, "PNG", 15, 10, 30, 20); // logo
//   }

//   doc.setFont("times", "bold");
//   doc.setFontSize(18);
//   doc.text(company?.name || "Company Name", 150, 15, { align: "center" });

//   doc.setFontSize(10);
//   doc.setFont("times", "normal");
//   doc.text(`CIN: ${company?.cin || "N/A"}`, 150, 22, { align: "center" });
//   doc.text(`Regt. Office: ${company?.address || "N/A"}`, 150, 28, { align: "center" });
//   doc.text(`Email: ${company?.email || "N/A"}`, 150, 34, { align: "center" });
//   doc.text(`Contact: ${company?.contact || "N/A"}`, 150, 40, { align: "center" });

//   // Line below header
//   doc.line(10, 45, 287, 45);

//   // === TITLE ===
//   doc.setFontSize(14);
//   doc.setFont("times", "bold");
//   doc.text("EMI Demand Sheet", 14, 55);

//   // === TABLE ===
//   const tableColumn = [
//     "#",
//     "Customer Name",
//     "Loan Number",
//     "EMI Number",
//     "EMI Amount",
//     "Principal",
//     "Interest",
//     "Outstanding",
//     "Due Date",
//     "Status"
//   ];

//   const tableRows = currentData.map((emi, index) => [
//     startIndex + index + 1,
//     emi.customerName,
//     emi.loanNumber,
//     emi.emiNumber,
//     emi.emiAmount,
//     emi.principalComponent,
//     emi.interestComponent,
//     emi.outstanding,
//     new Date(emi.dueDate).toLocaleDateString("en-IN"),
//     emi.status
//   ]);

//   autoTable(doc, {
//     startY: 60,
//     head: [tableColumn],
//     body: tableRows,
//     theme: "grid",
//     tableWidth: "auto",
//     styles: {
//       fontSize: 8,
//       cellPadding: 2,
//       overflow: "linebreak"
//     },
//     columnStyles: {
//       0: { cellWidth: 10 },
//       1: { cellWidth: 35 },
//       2: { cellWidth: 30 },
//       3: { cellWidth: 20 },
//       4: { cellWidth: 22 },
//       5: { cellWidth: 22 },
//       6: { cellWidth: 22 },
//       7: { cellWidth: 25 },
//       8: { cellWidth: 25 },
//       9: { cellWidth: 18 }
//     },
//     headStyles: {
//       fillColor: [99, 102, 241],
//       textColor: 255,
//       fontSize: 9
//     }
//   });

//   doc.save("EMI_Demand_Sheet.pdf");
// };

// const handleDownloadExcel = () => {
//   const worksheetData = currentData.map((emi, index) => ({
//     "#": startIndex + index + 1,
//     "Customer Name": emi.customerName,
//     "Loan Number": emi.loanNumber,
//     "EMI Number": emi.emiNumber,
//     "EMI Amount": emi.emiAmount,
//     "Principal": emi.principalComponent,
//     "Interest": emi.interestComponent,
//     "Outstanding": emi.outstanding,
//     "Due Date": new Date(emi.dueDate).toLocaleDateString("en-IN"),
//     "Status": emi.status
//   }));

//   const worksheet = XLSX.utils.json_to_sheet(worksheetData);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "EMI Report");

//   const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//   const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
//   saveAs(blob, "EMI_Demand_Sheet.xlsx");
// };

//   return (
//     <div className="EmiDueReport-wrapper">
//       <h1 className="EmiDueReport-title">Gold Loan Emi Due Report</h1>

//       {/* Filter buttons */}
//       <div className="EmiDueReport-filters">
//         {["pending", "today", "upcoming"].map((f) => (
//           <button
//             key={f}
//             className={`filter-btn ${filter === f ? "active" : ""}`}
//             onClick={() => {
//               setFilter(f);
//               setCurrentPage(1);
//             }}
//           >
//             {f.charAt(0).toUpperCase() + f.slice(1)}
//           </button>
//         ))}
//       </div>

//       {/* Controls: left rows selector, right PDF download */}
//       <div className="EmiDueReport-controls" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
//         <label>
//           Show{" "}
//           <select
//             value={rowsPerPage}
//             onChange={(e) => {
//               setRowsPerPage(Number(e.target.value));
//               setCurrentPage(1);
//             }}
//           >
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//             <option value={50}>50</option>
//             <option value={100}>100</option>
//           </select>{" "}
//           entries
//         </label>

//         <div style={{ display: "flex", gap: "10px" }}>
//             <button className="filter-btn" onClick={handleDownloadExcel}>
//               📊 Download Excel
//             </button>
//             <button className="filter-btn" onClick={handleDownloadPDF}>
//               📄 Download PDF
//             </button>
//           </div>
//       </div>

//       <div className="EmiDueReport-table-container">
//         <table className="EmiDueReport-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Customer Name</th>
//               <th>Loan Number</th>
//               <th>EMI Number</th>
//               <th>EMI Amount</th>
//               <th>Principal</th>
//               <th>Interest</th>
//               <th>Outstanding</th>
//               <th>Due Date</th>
//               <th>Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentData.length === 0 ? (
//               <tr>
//                 <td colSpan="10" className="EmiDueReport-empty">
//                   ✅ No records found
//                 </td>
//               </tr>
//             ) : (
//               currentData.map((emi, index) => (
//                 <tr key={emi.id}>
//                   <td>{startIndex + index + 1}</td>
//                   <td>{emi.customerName||"N/A"}</td>
//                   <td>{emi.loanNumber||"N/A"}</td>
//                   <td>{emi.emiNumber||"N/A"}</td>
//                   <td>{`₹${emi.emiAmount.toLocaleString()}`||"N/A"}</td>
//                   <td>{`₹${emi.principalComponent.toLocaleString()}`||"N/A"}</td>
//                   <td>{`₹${emi.interestComponent.toLocaleString()}`||"N/A"}</td>
//                   <td>{`₹${emi.outstanding.toLocaleString()}`||"N/A"}</td>
//                   <td>{new Date(emi.dueDate).toLocaleDateString("en-GB")||"N/A"}</td>
//                   <td>
//                     <span className={`EmiDueReport-status ${emi.status === "pending" ? "pending" : "paid"}`}>
//                       {emi.status}
//                     </span>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination controls */}
//       <div className="EmiDueReport-pagination">
//         <button className="pagination-btn" onClick={handlePrev} disabled={currentPage === 1}>
//           ⬅ Prev
//         </button>
//         <span className="pagination-info">
//           Page {currentPage} of {totalPages}
//         </span>
//         <button className="pagination-btn" onClick={handleNext} disabled={currentPage === totalPages}>
//           Next ➡
//         </button>
//       </div>
//     </div>
//   );
// };

// export default GoldLoanEmiDueReport;

import React, { useEffect, useState } from "react";
import axios from "axios";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "../css/EmiDueReport.css";
import { useNavigate } from "react-router-dom";

const GoldLoanEmiDueReport = () => {
  const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

  const [emis, setEmis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [company, setCompany] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedEmi, setSelectedEmi] = useState(null);
    const [paymentData, setPaymentData] = useState({
      amountPaid: "",
      paymentMode: "Cash",
      paymentDate: new Date().toISOString().split("T")[0],
    });
      const [submitting, setSubmitting] = useState(false);
    

  const navigate = useNavigate();

  // ================= COMPANY FETCH =================
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${superAdminId}`,
        );
        const data = await response.json();

        if (response.ok && data) {
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
          }
          setCompany(data);
        }
      } catch (err) {
        console.error("Error fetching company details:", err);
      }
    };

    if (superAdminId) fetchCompany();
  }, [superAdminId]);

  // ================= EMI FETCH =================
  useEffect(() => {
    const fetchEmis = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          "https://payyug.in/api/gold-loan/due-report/all",
          {
            params: {
              superAdminId,
              page: currentPage,
              limit: rowsPerPage,
            },
          },
        );

        setEmis(res.data.data || []);
        setTotalPages(res.data.totalPages || 1);
        setTotalRecords(res.data.totalRecords || 0);
      } catch (err) {
        setError("Failed to fetch EMI due report");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (superAdminId) fetchEmis();
  }, [currentPage, rowsPerPage, superAdminId]);

    const handlePayClick = (emi) => {
    setSelectedEmi(emi);
    setPaymentData({
      paymentAmout: emi.emiAmount,
      paymentMode: "Cash",
      paymentDate: new Date().toLocaleDateString("en-GB"),
    });
    setShowModal(true);
  };


const handleSubmitPayment = async () => {
  if (!paymentData.amountPaid) {
    alert("Enter amount");
    return;
  }

  try {
    setSubmitting(true);

    const response = await axios.post(
      `https://payyug.in/api/gold-loan/pay-loan/${selectedEmi.id}`,
      {
        loanId: selectedEmi.id,
        paymentAmount: Number(paymentData.amountPaid),
        paymentMode: paymentData.paymentMode,
        paymentDate: paymentData.paymentDate,
        collectedBy: superAdminId,
      }
    );

    // Axios success response check
    if (response.status === 200 || response.status === 201) {
      alert("✅ Payment Successful");

      setShowModal(false);
      setSelectedEmi(null);
    } else {
      alert(response.data?.message || "Payment Failed");
    }

  } catch (error) {
    alert(error.response?.data?.message || "Payment error");
  } finally {
    setSubmitting(false);
  }
};

  // Smooth scroll to table section
  useEffect(() => {
    window.scrollTo({
      top: 200,
      behavior: "smooth",
    });
  }, [currentPage]);

  if (loading)
    return <div className="EmiDueReport-loading">Loading EMI Report...</div>;
  if (error) return <div className="EmiDueReport-error">{error}</div>;

  const currentData = emis;
  const startIndex = (currentPage - 1) * rowsPerPage;

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };



  const formatCurrency = (amount) =>
    amount ? `₹${Number(amount).toLocaleString("en-IN")}` : "₹0";



  const handleDownloadPDF = async () => {
     const doc = new jsPDF("p", "mm", "a4");
            const pageWidth = doc.internal.pageSize.width;
            const pageHeight = doc.internal.pageSize.height;

          
    // ================= LOGO =================
    const logoX = 15;
    const logoY = 12;
    const logoSize = 25;
    const logoPadding = 2;

    // Border color & thickness
    doc.setDrawColor(0);
    doc.setLineWidth(0.2);

    // Calculate center of logo
    const centerX = logoX + logoSize / 2;
    const centerY = logoY + logoSize / 2;

    // Radius = half of logo + padding
    const radius = logoSize / 2 + logoPadding;

    // Draw circle
    doc.circle(centerX, centerY, radius);

    // Logo image
    if (company?.logoUrl) {
      try {
        const logoResp = await fetch(company.logoUrl);
        const logoBlob = await logoResp.blob();
        const reader = new FileReader();
        await new Promise((resolve) => {
          reader.onload = () => {
            doc.addImage(
              reader.result,
              "PNG",
              logoX,
              logoY,
              logoSize,
              logoSize,
            );
            resolve();
          };
          reader.readAsDataURL(logoBlob);
        });
      } catch {
        // silent fail
      }
    }

    // ================= COMPANY NAME (AUTO WRAP) =================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);

    const nameX = logoX + logoSize + 5;
    const nameY = 18;
    const nameMaxWidth = pageWidth - nameX - 15;

    const companyNameText = doc.splitTextToSize(
      (company?.name || "COMPANY NAME").toUpperCase(),
      nameMaxWidth,
    );

    doc.text(companyNameText, nameX, nameY);

    // Calculate Y after company name
    let currentY = nameY + companyNameText.length * 6;

    // ================= COMPANY DETAILS =================
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);

    const detailX = nameX;
    const detailMaxWidth = nameMaxWidth;

    // Address
    const addressText = doc.splitTextToSize(
      company?.address || "Company Address",
      detailMaxWidth,
    );
    doc.text(addressText, detailX, currentY);
    currentY += addressText.length * 5;

    // Email
    const emailText = doc.splitTextToSize(
      `Email: ${company?.email || "-"}`,
      detailMaxWidth,
    );
    doc.text(emailText, detailX, currentY);
    currentY += emailText.length * 5;

    // Phone
    const phoneText = doc.splitTextToSize(
      `Phone: ${company?.contact || "-"}`,
      detailMaxWidth,
    );
    doc.text(phoneText, detailX, currentY);
    currentY += phoneText.length * 5;

    // Divider
    doc.line(10, currentY + 4, pageWidth - 10, currentY + 4);

    // ================= REPORT TITLE =================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.text("Gold Loan Emi Due Report", pageWidth / 2, currentY + 14, {
      align: "center",
    });

    // === TABLE ===
    const tableColumn = [
      "#",
      "Customer Name",
      "Loan Number",
      "EMI Number",
      "EMI Amount",
      "Principal",
      "Interest",
      "Outstanding",
      "Due Date",
      "Status",
    ];

    const tableRows = currentData.map((emi, index) => [
      startIndex + index + 1,
      emi.customerName,
      emi.loanNumber,
      emi.emiNumber,
      emi.emiAmount,
      emi.principalComponent,
      emi.interestComponent,
      emi.outstanding,
      new Date(emi.dueDate).toLocaleDateString("en-IN"),
      emi.status,
    ]);

    autoTable(doc, {
           startY: currentY + 20,
           head: [tableColumn],
           body: tableRows,
     
           theme: "grid",
           styles: {
             fontSize: 7,
             cellPadding: 3,
             halign: "center",
           },
           headStyles: {
             fontStyle: "bold",
             fontSize: 7,
           },
           alternateRowStyles: {
             fillColor: [245, 245, 245],
           },
     
           didDrawPage: function () {
             const pageWidth = doc.internal.pageSize.width;
             const pageHeight = doc.internal.pageSize.height;
     
             doc.setDrawColor(0);
             doc.setLineWidth(0.2);
     
             // Page border on EVERY page
             doc.rect(8, 8, pageWidth - 16, pageHeight - 16);
           },
         });
   
         // ================= FOOTER =================
       const pageCount = doc.internal.getNumberOfPages();
       for (let i = 1; i <= pageCount; i++) {
         doc.setPage(i);
         doc.setFontSize(8);
         doc.setTextColor(100);
         doc.text(`Page ${i} of ${pageCount}`, pageWidth - 30, pageHeight - 10);
         doc.text("Generated by Collection System", 14, pageHeight - 10);
       }
   

    doc.save("Gold_Loan_Emi_Due_Report.pdf");
  };

  const handleDownloadExcel = () => {
    const worksheetData = currentData.map((emi, index) => ({
      "#": startIndex + index + 1,
      "Customer Name": emi.customerName || "N/A",
      "Loan Number": emi.loanNumber || "N/A",
      "EMI Number": emi.emiNumber || "N/A",
      "EMI Amount": emi.emiAmount || 0,
      Principal: emi.principalComponent || 0,
      Interest: emi.interestComponent || 0,
      Outstanding: emi.outstanding || 0,
      "Due Date": emi.dueDate
        ? new Date(emi.dueDate).toLocaleDateString("en-IN")
        : "N/A",
      Status: emi.status || "N/A",
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "EMI Report");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "EMI_Demand_Sheet.xlsx");
  };

  return (
    <div className="EmiDueReport-wrapper">
      <h1 className="EmiDueReport-title">Gold Loan Emi Due Report</h1>

      <div
        className="EmiDueReport-controls"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "16px",
        }}
      >
        <label>
          Show{" "}
          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1); // 🔥 always reset
            }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={50000}>All</option>
          </select>{" "}
          entries
        </label>

        <div style={{ display: "flex", gap: "10px" }}>
          <button
            type="button"
            className="filter-btn"
            onClick={handleDownloadExcel}
          >
            📊 Download Excel
          </button>
          <button className="filter-btn" onClick={handleDownloadPDF}>
            📄 Download PDF
          </button>
        </div>
      </div>

      <div className="EmiDueReport-table-container">
        <table className="EmiDueReport-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Customer Name</th>
              <th>Loan Number</th>
              <th>EMI Number</th>
              <th>EMI Amount</th>
              <th>Principal</th>
              <th>Interest</th>
              <th>Outstanding</th>
              <th>Due Date</th>
              <th>Status</th>
              {/* <th>Action</th> */}
            </tr>
          </thead>
          <tbody>
            {currentData.length === 0 ? (
              <tr>
                <td colSpan="10" className="EmiDueReport-empty">
                  ✅ No records found
                </td>
              </tr>
            ) : (
              currentData.map((emi, index) => (
                <tr key={emi.id}>
                  <td>{startIndex + index + 1}</td>
                  <td>{emi.customerName || "N/A"}</td>
                  <td>{emi.loanNumber || "N/A"}</td>
                  <td>{emi.emiNumber || "N/A"}</td>
                  <td>{formatCurrency(emi.emiAmount)||"N/A"}</td>
                  <td>{formatCurrency(emi.principalComponent)||"N/A"}</td>
                  <td>{formatCurrency(emi.interestComponent)||"N/A"}</td>
                  <td>{formatCurrency(emi.outstanding)||"N/A"}</td>
                  <td>
                    {emi.dueDate
                      ? new Date(emi.dueDate).toLocaleDateString("en-GB")
                      : "N/A"}
                  </td>
                  <td>
                    <span
                      className={`EmiDueReport-status ${
                        emi.status === "pending" ? "pending" : "paid"
                      }`}
                    >
                      {emi.status}
                    </span>
                  </td>
                  {/* <td>
                    <button
                          className="viewemiloandata-btn-pay"
                          onClick={() => handlePayClick(emi)}
                        >
                          Pay
                        </button>
                  </td> */}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="EmiDueReport-pagination">
        <button
          type="button"
          className="pagination-btn"
          onClick={handlePrev}
          disabled={currentPage === 1}
        >
          ⬅ Prev
        </button>

        <span className="pagination-info">
          Page {currentPage} of {totalPages} | Total Records: {totalRecords}
        </span>

        <button
          type="button"
          className="pagination-btn"
          onClick={handleNext}
          disabled={currentPage === totalPages}
        >
          Next ➡
        </button>
      </div>


        {/* Payment Modal */}
      {showModal && (
        <div className="viewemiloandata-modal-overlay">
          <div className="viewemiloandata-modal">
            <h3>Pay EMI (No: {selectedEmi?.emiNumber || selectedEmi?.id})</h3>
            <label>
              Payment Amount:
              <input
                type="number"
                value={paymentData.paymentAmout}
                onChange={(e) =>
                  setPaymentData({ ...paymentData, paymentAmout: e.target.value })
                }
              />
            </label>
            <label>
              Payment Mode:
              <select
                value={paymentData.paymentMode}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    paymentMode: e.target.value,
                  })
                }
              >
                <option value="Cash">Cash</option>
                <option value="Card">Card</option>
                <option value="UPI">UPI</option>
                <option value="NetBanking">Net Banking</option>
              </select>
            </label>
            <label>
              Payment Date:
              <input
                type="date"
                value={paymentData.paymentDate}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    paymentDate: e.target.value,
                  })
                }
              />
            </label>
            <div className="modal-actions">
              <button onClick={() => setShowModal(false)}>Cancel</button>
              <button onClick={handleSubmitPayment} disabled={submitting}>
                {submitting ? "Processing..." : "Confirm Pay"}
              </button>
            </div>
          </div>
        </div>
      )}

    
    </div>
  );
};

export default GoldLoanEmiDueReport;
